// Container-query plumbing for the CAM prototype.
//
// The control panel renders at a fixed logical width inside the laptop frame and
// is then CSS-scaled, so window-based MUI breakpoints (useMediaQuery, the
// display:{xs…md…} sx form) never fire — and pinning the stage viewport toggle to
// a width only changes the element's width, not the window's. Container queries
// keyed off the prototype root are the only thing that actually responds to the
// simulated width, so the CAM layout uses these instead of media queries.

export const CAM_CONTAINER = 'cam';

// Marks the prototype root as the size container the queries below resolve
// against. Spread onto the root surface's sx.
export const camContainerSx = {
  containerType: 'inline-size',
  containerName: CAM_CONTAINER,
} as const;

// Below md (900px container width) is the compact layout: the nav rail collapses
// to a hamburger-drawer, the care-search two-pane stacks, and gutters tighten.
// 899.95 (not 900) so the regular/compact queries never both match at exactly md.
export const CAM_COMPACT = `@container ${CAM_CONTAINER} (max-width: 899.95px)`;

// The mirror of CAM_COMPACT — md and up. Used to force the compact-only drawer
// hidden if the stage is resized back up to desktop while it's open.
export const CAM_REGULAR = `@container ${CAM_CONTAINER} (min-width: 900px)`;
